import type { CopyCatalog } from "./copyTypes";

export const FI_COPY: CopyCatalog = {
  "common.loading": "Ladataan…",
  "common.yes": "Kyllä",
  "common.no": "Ei",
  "common.notProvided": "Ei ilmoitettu",
  "common.notRequired": "Ei vaadita",
  "common.requested": "Pyydetty",
  "nav.back": "Takaisin",
  "nav.continue": "Jatka",
  "nav.sendRequest": "Lähetä pyyntö",
  "nav.sending": "Lähetetään…",
  "alert.completeFields": "Täytä merkityt kentät ennen jatkamista.",
  "fill.filled": "Täytetty",
  "fill.notFound": "Ei löytynyt",
  "fill.shipmentToo": "Lähetys täytetty myös: {detail}",
  "fill.palletMany": "lavaa",

  "choose.title": "Miten haluatte pyytää tarjouksen?",
  "choose.manual.title": "Manuaalinen syöttö",
  "choose.manual.description": "Syöttäkää lähetyksen tiedot vaiheittain ohjatulla lomakkeella.",
  "choose.manual.action": "Syötä tiedot manuaalisesti",
  "choose.quickfill.title": "Quick Fill",
  "choose.quickfill.description":
    "Liittäkää lähetyksen tiedot tai lataakaa asiakirja, niin täytämme lomakkeen puolestanne.",
  "choose.quickfill.action": "Aloita pikatäyttö",

  "steps.route": "Reitti ja tilaus",
  "steps.shipment": "Lähetys",
  "steps.services": "Lisäpalvelut",
  "steps.contact": "Yhteystiedot",
  "steps.review": "Tarkistus",

  "page.route": "Reitti ja tilaus",
  "page.routeSection": "Reitti",
  "page.shipment": "Lähetyksen tiedot",
  "page.services": "Lisäpalvelut",
  "page.contact": "Yhteystiedot",
  "page.contactSection": "Yhteystietonne",
  "page.review": "Tarkistus",
  "page.quickFill": "Quick Fill",
  "page.analyzing": "Asiakirjaa analysoidaan",

  "route.hintPostcode": "Syöttäkää postinumero tai paikkakunta lastaukseen ja purkuun.",
  "route.hintFullAddress": "Syöttäkää lastauksen ja purun täydellinen osoite.",
  "route.unsupported": "Tätä reittiä ei tueta. Käyttäkää lomaketta maille {loadCountry} ja {unloadCountry}.",
  "route.loading": "Lastaus",
  "route.unloading": "Purku",
  "route.origin": "Lähtö",
  "route.destination": "Määränpää",
  "route.country": "Maa",
  "route.selectCountry": "Valitse maa",
  "route.postcode": "Postinumero",
  "route.postcodePlaceholder": "esim. 00100",
  "route.city": "Paikkakunta",
  "route.cityPlaceholder": "Syötä paikkakunta",
  "route.street": "Kadunnimi",
  "route.streetPlaceholder": "Syötä katu",
  "route.house": "Talonumero",
  "route.housePlaceholder": "esim. 12",
  "route.pickupDate": "Toivottu noutopäivä:",
  "route.unloadDate": "Toivottu purkupäivä:",
  "route.datePlaceholder": "pp.kk.vvvv",
  "date.clear": "Tyhjennä päivämäärä",
  "date.closeCalendar": "Sulje kalenteri",
  "date.openCalendar": "Avaa kalenteri",
  "route.specificDateHint":
    "Tavaroille, jotka ovat saatavilla tiettynä päivänä. Muuten pyrimme nopeimpaan vaihtoehtoon.",
  "route.orderDetails": "Tilauksen tiedot",

  "shipment.goods": "Tavaroiden kuvaus",
  "shipment.goodsPlaceholder": "Mitä haluatte kuljettaa?",
  "shipment.weight": "Kokonaispaino",
  "shipment.qty": "Määrä",
  "shipment.type": "Tyyppi",
  "shipment.dims": "Mitat / LDM",
  "shipment.stackable": "Pinottava",
  "shipment.addRow": "Lisää lähetysrivi",
  "shipment.totalLines": "Rivejä yhteensä: {count}",
  "shipment.selectDims": "Valitse mitat",
  "shipment.dimsNa": "Mitat eivät koske",
  "shipment.sizeModeDims": "P × L × K",
  "shipment.sizeModeLdm": "LDM",
  "shipment.removeRow": "Poista lähetysrivi {n}",
  "shipment.lineLabel": "{text}, rivi {n}",
  "shipment.quantity": "Määrä",
  "qty.decrease": "Vähennä määrää",
  "qty.increase": "Lisää määrää",
  "shipment.lengthCm": "Pituus (cm)",
  "shipment.widthCm": "Leveys (cm)",
  "shipment.heightCm": "Korkeus (cm)",
  "shipment.dimensions": "Mitat",
  "shipment.size": "Koko",
  "shipment.ldm": "LDM",

  "pallet.euro": "Euro",
  "pallet.block": "Block",
  "pallet.ibc": "IBC",
  "pallet.cp3": "CP3",
  "pallet.half": "Puolilava",
  "pallet.size80x60": "80×60",
  "pallet.size120x120": "120×120",
  "pallet.size150x80": "150×80",
  "pallet.custom": "Erikoismitta",
  "pallet.unspecified": "LDM",

  "services.aria": "Lisäpalvelut",
  "services.pill.adr": "ADR",
  "services.pill.temp": "Lämpötila",
  "services.pill.tail": "Takalaitanostin",
  "services.pill.ftl": "FTL",
  "services.pill.time": "Aikaikkuna",
  "services.pill.ref": "Viite / huomautukset",
  "services.pill.references": "Viitteet",
  "services.pill.attachments": "Lisäliitteet",
  "services.adrClass": "ADR-luokka",
  "services.selectClass": "Valitse luokka",
  "services.unNumber": "YK-numero",
  "services.unPlaceholder": "esim. 1203",
  "services.min": "Min",
  "services.max": "Max",
  "services.tailLoad": "Takalaitanostin lastauksessa",
  "services.tailUnload": "Takalaitanostin purussa",
  "services.ftlCopy": "Täysi kuorma pyydetty.",
  "services.invoiceRef": "Laskuviite",
  "services.reference": "Viite",
  "services.loadingRef": "Lastausviite",
  "services.unloadingRef": "Purkuviite",
  "services.notes": "Huomautukset",
  "services.notesPlaceholder": "esim. erityisohjeet",
  "services.deadline": "Toivottu toimitusmääräaika:",
  "services.deliveryHint":
    "Tavaroille, jotka on toimitettava tiettynä päivänä. Muuten pyrimme nopeimpaan vaihtoehtoon.",
  "services.loadingTime": "Lastausaika",
  "services.unloadingTime": "Purkuaika",
  "services.window": "Aikaikkuna",
  "services.fixed": "Kiinteä",
  "services.at": "klo",
  "services.from": "alkaen",
  "services.to": "asti",
  "services.timeTypeAria": "{title} tyyppi",
  "services.addFiles": "Lisää tiedostoja",
  "services.attachHint":
    "JPEG, PNG, GIF, WebP tai PDF. Enintään {maxFiles} tiedostoa, {maxFileMb} Mt kukin, yhteensä {maxTotalMb} Mt.",
  "services.adrClass1": "1 Räjähteet",
  "services.adrClass2": "2 Kaasut",
  "services.adrClass3": "3 Palavat nesteet",
  "services.adrClass4": "4 Palavat kiinteät aineet",
  "services.adrClass5": "5 Hapettavat aineet",
  "services.adrClass6": "6 Myrkylliset / tartuntavaaralliset aineet",
  "services.adrClass7": "7 Radioaktiiviset aineet",
  "services.adrClass8": "8 Syövyttävät aineet",
  "services.adrClass9": "9 Muut vaaralliset aineet",
  "services.summary.adr": "Vaaralliset aineet (ADR)",
  "services.summary.temp": "Lämpötilasäädelty",
  "services.summary.time": "Aikaikkunat",
  "services.summary.refNotes": "Viite ja huomautukset",
  "services.summary.tail": "Takalaitanostin",
  "services.summary.ftl": "FTL",
  "services.summary.attachments": "Lisäliitteet",
  "services.tail.loadUnload": "Lastaus ja purku",
  "services.tail.loadOnly": "Vain lastaus",
  "services.tail.unloadOnly": "Vain purku",
  "services.time.load": "Lastaus: {value}",
  "services.time.unload": "Purku: {value}",
  "services.time.deadline": "Määräaika: {value}",
  "services.time.fixedSuffix": "{time} (kiinteä)",
  "services.time.windowRange": "{from}–{until}",
  "services.adr.yes": "Kyllä",
  "services.adr.classUn": "Luokka {class}, YK {un}",
  "services.adr.classOnly": "Luokka {class}",
  "services.adr.unOnly": "YK {un}",
  "services.temp.range": "{min}°C–{max}°C",
  "services.ref.invoice": "Lasku: {value}",
  "services.ref.loading": "Lastaus: {value}",
  "services.ref.unloading": "Purku: {value}",

  "contact.name": "Nimi",
  "contact.company": "Yritys",
  "contact.email": "Sähköposti",
  "contact.phone": "Puhelin",
  "contact.comment": "Lisähuomautus",
  "contact.privacyBefore":
    "Hyväksyn henkilötietojeni käsittelyn Neele-Vatin ",
  "contact.privacyLink": "tietosuojakäytännön",
  "contact.privacyAfter": " mukaisesti.",

  "result.thankYou": "Kiitos! Pyyntönne on vastaanotettu.",
  "result.teamWillContact":
    "Tiimimme ottaa teihin yhteyttä 60 minuutin kuluessa toimistoaikana.",
  "result.teamWillContactEmail":
    "Tiimimme ottaa teihin yhteyttä 60 minuutin kuluessa toimistoaikana osoitteeseen {email}.",
  "result.previewMode": "Esikatselutila — tätä pyyntöä ei ole oikeasti lähetetty.",
  "result.previewFiles": " Huom: tiedostoja ei voi lähettää esikatselutilassa.",
  "result.yourReference": "Viitteenne",
  "result.copy": "Kopioi",
  "result.copied": "Kopioitu",
  "result.nextTitle": "Mitä tapahtuu seuraavaksi",
  "result.next1": "Pyyntö vastaanotettu.",
  "result.next2": "Pyyntöä käsitellään.",
  "result.next3": "Vastaus 60 minuutin kuluessa sähköpostitse.",
  "result.logged":
    "Olemme kirjanneet pyyntönne. Jos ette kuule meistä, ottakaa yhteyttä alla olevilla tiedoilla.",
  "result.newQuote": "Aloita uusi tarjous",
  "result.sendFailed": "Pyyntöä ei voitu lähettää",
  "result.preferDirect": "Haluatteko ottaa yhteyttä suoraan?",
  "result.backToEdit": "Takaisin muokkaukseen",
  "result.tryAgain": "Yritä uudelleen",
  "result.hideDetails": "Piilota tiedot",
  "result.viewSent": "Näytä lähettämämme tiedot",
  "result.error.rateLimited":
    "Olette tehneet paljon pyyntöjä lyhyessä ajassa. Odottakaa hetki ja yrittäkää uudelleen.",
  "result.error.forbidden":
    "Tämä pyyntö estettiin. Yrittäkää uudelleen tai ottakaa meihin suoraan yhteyttä.",
  "result.error.network":
    "Pyyntöä ei voitu lähettää juuri nyt. Tarkistakaa yhteys ja yrittäkää uudelleen.",
  "result.error.tooLarge":
    "Pyyntö on liian suuri lähetettäväksi. Käyttäkää pienempiä liitteitä tai lyhyempää huomautusta.",
  "result.error.unsupportedType": "Käyttäkää vain JPEG-, PNG-, GIF-, WebP- tai PDF-tiedostoja.",
  "result.error.emailUnavailable":
    "Pyyntöä liitteineen ei voitu lähettää sähköpostitse. Yrittäkää uudelleen tai ottakaa meihin suoraan yhteyttä.",

  "qf.hint":
    "Liittäkää sähköposti tai lähetyksen tiedot tai liittäkää kuva tai PDF. Tämä korvaa jo syötetyt tiedot.",
  "qf.placeholder":
    "esim. 24 euroalustaa 3011 Rotterdamista 20095 Hampuriin, 12 000 kg, nouto huomenna…",
  "qf.ariaPaste": "Analysoitavat lähetyksen tiedot",
  "qf.attach": "Liitä kuva tai PDF",
  "qf.disclaimer":
    "Kaikki liittämänne tai lisäämänne käytetään vain tämän pyynnön täyttämiseen. Tiedot käsittelee asiakirja-analyysipalvelumme, eikä niitä säilytetä lomakkeen täyttämisen jälkeen.",
  "qf.fillForm": "Täytä lomake",
  "qf.working": "Käsitellään…",
  "qf.analyzing": "Tietoja analysoidaan…",
  "qf.noFields": "Kenttiä ei tunnistettu. Lisätkää lisätietoja.",
  "qf.rateLimited": "Olette tehneet liian monta pyyntöä. Odottakaa hetki ja yrittäkää uudelleen.",
  "qf.blocked": "Tämä pyyntö estettiin. Ottakaa yhteyttä, jos tämä on odottamatonta.",
  "qf.extractUnavailable":
    "Asiakirja-analyysi ei ole juuri nyt käytettävissä. Liittäkää lähetyksen tiedot sen sijaan.",
  "qf.genericError": "Jokin meni pieleen. Tarkistakaa verkko tai yrittäkää uudelleen.",
  "qf.analyzeTitle": "Asiakirjaa analysoidaan...",
  "qf.analyzeSub": "Tämä kestää yleensä muutaman sekunnin",
  "qf.analyzeStep1": "Asiakirjan rakenteen luku",
  "qf.analyzeStep2": "Perustietojen poiminta",
  "qf.analyzeStep3": "Lähetysrivien tunnistus",
  "qf.removeFile": "Poista {name}",

  "error.loadCountry": "Valitkaa lastausmaa.",
  "error.loadPostal": "Syöttäkää lastauksen postinumero.",
  "error.loadCity": "Syöttäkää lastauksen paikkakunta.",
  "error.loadStreet": "Syöttäkää lastauksen kadunnimi.",
  "error.loadHouseNumber": "Syöttäkää lastauksen talonumero.",
  "error.unloadCountry": "Valitkaa purkuma.",
  "error.unloadPostal": "Syöttäkää purun postinumero.",
  "error.unloadCity": "Syöttäkää purun paikkakunta.",
  "error.unloadStreet": "Syöttäkää purun kadunnimi.",
  "error.unloadHouseNumber": "Syöttäkää purun talonumero.",
  "error.pickupDate": "Valitkaa noutopäivä.",
  "error.unloadDate": "Valitkaa purkupäivä.",
  "error.invalidDate": "Syöttäkää kelvollinen päivämäärä.",
  "error.totalWeight": "Syöttäkää kokonaispaino.",
  "error.goods": "Kuvatkaa tavarat.",
  "error.loadCityOrPostal": "Syöttäkää lastauksen postinumero tai paikkakunta.",
  "error.unloadCityOrPostal": "Syöttäkää purun postinumero tai paikkakunta.",
  "error.loadPostalInvalid": "Syöttäkää tunnistettu lastauksen postinumero.",
  "error.loadCityInvalid": "Syöttäkää tunnistettu lastauksen paikkakunta.",
  "error.unloadPostalInvalid": "Syöttäkää tunnistettu purun postinumero.",
  "error.unloadCityInvalid": "Syöttäkää tunnistettu purun paikkakunta.",
  "error.pickupPast": "Noutopäivä ei voi olla menneisyydessä.",
  "error.unloadPast": "Purkupäivä ei voi olla menneisyydessä.",
  "error.unloadBeforePickup": "Purkupäivä ei voi olla ennen noutopäivää.",
  "error.weightRange": "Syöttäkää paino väliltä 1–{max} kg.",
  "error.rangePlain": "{min}–{max}.",
  "error.rangeLdm": "{min}–{max} LDM.",
  "error.rangeCm": "{min}–{max} cm.",
  "error.adrUn": "Syöttäkää 4-numeroinen YK-numero.",
  "error.invoiceRef": "Syöttäkää laskuviite.",
  "error.loadingRef": "Syöttäkää lastausviite.",
  "error.unloadingRef": "Syöttäkää purkuviite.",
  "error.tempMin": "Syöttäkää vähimmäislämpötila.",
  "error.tempMax": "Syöttäkää enimmäislämpötila.",
  "error.tempOrder": "Maxin on oltava vähintään min.",
  "error.enterNumber": "Syöttäkää luku.",
  "error.deliveryPast": "Toimitusmääräaika ei voi olla menneisyydessä.",
  "error.deliveryBeforePickup": "Toimitusmääräaika ei voi olla ennen noutopäivää.",
  "error.tailSides": "Valitkaa lastaus, purku tai molemmat.",
  "error.attachOne": "Liittäkää vähintään yksi tiedosto.",
  "error.enterTime": "Syöttäkää kellonaika.",
  "error.enterStartTime": "Syöttäkää aloitusaika.",
  "error.enterEndTime": "Syöttäkää päättymisaika.",
  "error.enterMinutes": "Syöttäkää minuutit.",
  "error.completeTime": "Syöttäkää täydellinen kellonaika.",
  "error.enterEmail": "Syöttäkää sähköpostiosoite.",
  "error.validEmail": "Syöttäkää kelvollinen sähköpostiosoite.",
  "error.validPhone": "Syöttäkää kelvollinen puhelinnumero.",
  "error.personalEmail": "Henkilökohtaisia sähköpostiosoitteita ei hyväksytä.",
  "error.enterName": "Syöttäkää nimenne.",
  "error.enterCompany": "Syöttäkää yrityksenne.",
  "error.privacy": "Hyväksykää jatkaaksenne.",
  "error.quickFillEmpty":
    "Liittäkää lähetyksen tiedot tai kuva tai PDF lomakkeen täyttämiseksi.",
  "error.maxFiles": "Voitte liittää enintään {max} tiedostoa.",
  "error.maxFileMb": "Kukin tiedosto saa olla enintään {max} Mt.",
  "error.maxTotalMb": "Liitteet saavat olla yhteensä enintään {max} Mt.",
  "error.filesSkippedType": "Joitakin tiedostoja ohitettiin. Käyttäkää JPEG-, PNG-, GIF-, WebP- tai PDF-tiedostoja.",
  "error.emptySkipped": "Tyhjät tiedostot ohitettiin.",
  "error.fileEmpty": "Valittu tiedosto on tyhjä.",
  "error.filesEmptyOrType": "Osa tiedostoista oli tyhjiä tai ne eivät olleet JPEG, PNG, GIF, WebP tai PDF.",
  "error.attachType": "Liittäkää JPEG, PNG, GIF, WebP tai PDF.",
  "error.subjectLong": "Aihe on liian pitkä.",
  "error.emailTextLong": "Pyynnön tiedot ovat liian pitkät.",
  "error.shortenSubject": "Lyhentäkää tätä arvoa, jotta sähköpostin aihe pysyy {max} merkin sisällä.",
  "error.shortenBody":
    "Lyhentäkää lähetyksen tietoja tai huomautusta, jotta sähköposti pysyy {max} merkin sisällä.",

  "announce.choose": "Valitkaa, miten haluatte pyytää tarjouksen",
  "announce.quickfill": "Pikatäyttö: liittäkää tiedot tai lataakaa asiakirja",
  "announce.route": "Vaihe 1/5: reitti ja tilaus",
  "announce.shipment": "Vaihe 2/5: lähetyksen tiedot",
  "announce.services": "Vaihe 3/5: lisäpalvelut",
  "announce.contact": "Vaihe 4/5: yhteystiedot",
  "announce.review": "Vaihe 5/5: tarkistakaa pyyntö",
  "announce.received": "Pyyntö vastaanotettu",
  "announce.sendFailed": "Pyyntöä ei voitu lähettää",
  "announce.sendFailedAttempt": "Pyyntöä ei voitu lähettää (yritys {n})",
  "announce.completeFields": "Täytä merkityt kentät ennen jatkamista.",
  "announce.sending": "Pyyntöänne lähetetään…",
};
